module.exports = __webpack_public_path__ + "img/teamImg21.98eb2417.jpg";